export default "__VITE_ASSET__22f75df9__"